import { render, staticRenderFns } from "./DesignSystemSidebar.vue?vue&type=template&id=905b5ad6&scoped=true"
import script from "./DesignSystemSidebar.vue?vue&type=script&lang=js"
export * from "./DesignSystemSidebar.vue?vue&type=script&lang=js"
import style0 from "./DesignSystemSidebar.vue?vue&type=style&index=0&id=905b5ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b5ad6",
  null
  
)

export default component.exports